import { prettyDebugLog } from './debugLog/prettyDebugLog';

const DEBUG_ENABLED = typeof location !== 'undefined' && new URLSearchParams(location.search).get('rumdebug') === '1';

type DebugInfo = Parameters<typeof prettyDebugLog>[0];

/**
 * Логирует переданные данные если включен дебаг
 * @param infoFactory фабрика, возвращающая информацию для лога
 */
export function debugLog(infoFactory: () => DebugInfo) {
    if (DEBUG_ENABLED) {
        const logValue = infoFactory();
        prettyDebugLog({
            ...logValue,
            tags: ['RUM', ...logValue.tags.filter(Boolean)],
        });
    }
}
